
const Article = {
        path: '/ConteMange/Article',
        component: resolve => require(['@/views/ConteMange/Article'], resolve),
        name: 'Article',
        meta: {
          title: '文章管理',
          keepActive:true
        }
      };
const ddHeadlines ={
        path: '/ConteMange/ddHeadlines',
        component: resolve => require(['@/views/ConteMange/ddHeadlines'], resolve),
        name: 'ddHeadlines',
        meta: {
          title: '叮叮头条'
        }
      };
const Classif = {
  path: '/ConteMange/Classif',
  component: resolve => require([ '@/views/ConteMange/Classif' ], resolve),
  name: 'Classif',
  meta: {
    title: '文章分类'
  }
};
const regionManage = {
  path: '/ConteMange/regionManage',
  component: resolve => require(['@/views/ConteMange/regionManage'], resolve),
  name: 'regionManage',
  meta: {
    title: '区域管理'
  }
};
const broadCast = {
  path: '/ConteMange/broadCast',
  component: resolve => require(['@/views/ConteMange/broadCast'], resolve),
  name: 'broadCast',
  meta: {
    title: '广播消息'
  }
};

export default [Article,ddHeadlines,Classif,regionManage,broadCast]



// WEBPACK FOOTER //
// ./src/router/modules/ConteMange.js